import type { SVGProps } from "react";
export interface ScribbleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ScribbleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ScribbleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.749 2.01c1.239-.273 2.669-.2 3.592.936l.197.278c.408.659.453 1.394.296 2.077-.168.736-.575 1.459-1.044 2.123-.939 1.33-2.392 2.784-3.733 4.132-1.39 1.398-2.661 2.687-3.426 3.794-.384.556-.565.964-.615 1.238-.038.208.003.269.069.337.01.01.004.028.111.017.166-.016.45-.108.875-.353.85-.49 1.855-1.344 2.98-2.305 1.068-.914 2.252-1.932 3.336-2.56.543-.314 1.156-.588 1.787-.663.68-.08 1.39.076 1.972.62.476.445.71 1.009.718 1.61.007.55-.175 1.063-.383 1.486-.408.83-1.121 1.708-1.71 2.445-.643.807-1.163 1.473-1.426 2.032-.127.269-.144.414-.142.469 0 .008-.01.007.032.047.082.076.226.187.72.014.547-.191 1.31-.679 2.29-1.566l.09-.073a1.126 1.126 0 0 1 1.42 1.742l-.396.347c-.919.784-1.812 1.377-2.662 1.674-1.023.358-2.125.32-2.997-.493a2.28 2.28 0 0 1-.746-1.607c-.02-.558.152-1.08.356-1.514.4-.847 1.11-1.734 1.702-2.475.648-.81 1.176-1.475 1.45-2.035.128-.258.15-.4.152-.455l-.005-.005c-.017-.016-.032-.044-.171-.028-.189.023-.49.126-.923.377-.867.502-1.88 1.362-3.003 2.322-1.067.912-2.247 1.925-3.316 2.543-.535.308-1.145.58-1.774.644-.688.07-1.392-.117-1.949-.688-.654-.672-.817-1.507-.67-2.31.134-.739.526-1.46.977-2.113.903-1.309 2.342-2.753 3.682-4.101 1.39-1.398 2.684-2.704 3.49-3.844.402-.571.617-1.01.69-1.327.046-.203.028-.307-.008-.375l-.04-.059c-.122-.151-.446-.36-1.36-.158-.888.196-2.034.731-3.305 1.564-2.531 1.66-5.262 4.307-6.989 6.94a1.125 1.125 0 1 1-1.88-1.234C3.965 8.57 6.922 5.708 9.693 3.891c1.38-.906 2.79-1.602 4.055-1.881Z"
      />
    </svg>
  );
}
